import type { LinkedContextItem } from '../../../contracts/projects/linked-context';
import type { ProjectsComposerPromptDraft } from '../../../data/projects/projects-composer-editor-draft';

export interface RestorableSentTurn {
  draft: ProjectsComposerPromptDraft;
  files?: readonly File[];
  linkedItems?: readonly LinkedContextItem[];
}

export const getLastSentTurnToRestore = (args: {
  key: string;
  draftEmpty: boolean;
  stagedFileCount: number;
  lastSentTurn: RestorableSentTurn | null;
}): RestorableSentTurn | null => {
  if (args.key !== 'ArrowUp') return null;
  if (!args.draftEmpty || args.stagedFileCount > 0 || !args.lastSentTurn) return null;
  return args.lastSentTurn;
};

export const shouldQueueTurnOnSend = (
  turnInFlight: boolean,
  isSubmitting: boolean
): boolean => turnInFlight || isSubmitting;
